import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const portalApi = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

portalApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("portal_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

portalApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("portal_token");
      localStorage.removeItem("portal_user");
      window.location.href = "/portal/login";
    }
    return Promise.reject(err);
  }
);

export default portalApi;
